var Heroes = $.extend(false, BaseModule ,{
    api_route : 'heroes',

	data : {
		module      : 'heroes',
		page        : 1,
		offset      : 42,
        with        : 'file:locations',
        view        : 'grid',
        pagination  : true
	},
    save_order:function(){
        var module_name = this.data.module;
        var module = this;

        var selection = [];
        $('input[name="order_item_id[]"]').each(function(){
            selection.push($(this).val());
        });


        $.ajax({
            url : API + 'heroes/order',
            method:'POST',
            data:{ order_item_id: selection },
            success:function(data){
                $("#heroes-dialog-list").modal('hide');

            }});
        return false;
    },
	init:function(){}
});

$(document).ready(function(){
    "use strict";
    Heroes.init();
});
